// client/src/pages/Game/Battlefield/components/SettingsMenu.jsx

import React from 'react';

/**
 * Composant pour afficher le menu de réglages
 * @param {Object} props Les propriétés du composant
 * @param {Boolean} props.devMode Si le mode développeur est activé
 * @param {Function} props.onToggleDevMode Fonction pour activer/désactiver le mode développeur
 * @param {Function} props.onResetPositions Fonction pour réinitialiser les positions
 * @param {Boolean} props.showGameLog Si le journal de jeu est affiché
 * @param {Function} props.onToggleGameLog Fonction pour afficher/masquer le journal de jeu
 * @param {Function} props.onSurrenderGame Fonction pour abandonner la partie
 * @param {Function} props.onClose Fonction pour fermer le menu
 * @returns {JSX.Element} Le composant SettingsMenu
 */
const SettingsMenu = ({
  isAdmin,
  devMode,
  onToggleDevMode,
  onResetPositions,
  showGameLog,
  onToggleGameLog,
  onSurrenderGame,
  onClose
}) => {
  return (
    <div className="settings-menu">
      <button onClick={onClose} className="close-settings">
        ✕
      </button>
      <div className="settings-title">Réglages</div>
      <div className="settings-options">
        {isAdmin && (
        <div className="settings-option">
          <button 
            onClick={onToggleDevMode}
            className={`settings-button ${devMode ? 'active' : ''}`}
          >
            Mode Développeur: {devMode ? 'Activé' : 'Désactivé'}
          </button>
        </div>
        
        )}
        {isAdmin && devMode && (
          <div className="settings-option">
            <button 
              onClick={onResetPositions}
              className="settings-button"
            >
              Réinitialiser Positions
            </button>
          </div>
        )}
        
        <div className="settings-option">
          <button 
            onClick={onToggleGameLog}
            className="settings-button"
          >
            {showGameLog ? 'Masquer Journal' : 'Afficher Journal'}
          </button>
        </div>
        
        <div className="settings-option">
          <button 
            onClick={() => {
              if (window.confirm('Voulez-vous vraiment abandonner la partie?')) {
                onSurrenderGame();
              }
            }}
            className="settings-button danger"
          >
            Abandonner la Partie
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsMenu;